import React, { useState, useEffect, useMemo, useRef } from "react";
import { Row, Col, Button, Form, Space, Typography, message, Spin, DatePicker, Card, Tag } from "antd";
import { useForm, useWatch } from "react-hook-form";
import Grid from "../../../../atoms/Grid";
import { InputField, RangePickerField, ReactSelectField, TextAreaField } from "../../../../atoms/FormElement";
import { InputNumberFieldV2 as InputNumberField } from "../../../../atoms/FormElement/InputNumberField";
import { updatePDCStatus } from "../../ducks/actions";
import { dateByformat } from "../../../../../utils/dateHelper";

import { ExclamationCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { formatString } from "../../../../../utils/formatString";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { getConfigData } from "../../../BookingForm/ducks/actions";
import { useDispatch } from "react-redux";
import {
  bouncedReasons,
  defaultFormVal,
  formattedBankList,
  gridCol,
  paymentModeOptions,
  paymentModeRendering,
  removeEmptyValues,
  visibilityOptions,
} from "../../utili";
import { calCulateVatInPercent } from "../../../../../utils/helper";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { useInitializePaymentData } from "./hook/useInitializePaymentData";
import { useTotalOverpaymentAmount } from "./hook/useTotalOverpaymentAmount";
import { rangePickerInitialValue } from "../../../BookingForm/components/utils";
import { convertToSpacedLowerCase, currencyFormat, DATE_FORMATS, formatDate } from "../../../../libs/utils";
import { ApprovalBar } from "../../../../molecules/ApprovalBar";
import { Calendar } from "../../../../../assets/svg";

var _ = require("lodash");

const defaultVal = defaultFormVal;

const { Paragraph, Text } = Typography;
const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 150,
};

const ModifyPaymentStatus = (props) => {
  const { data, selectedOption } = props;
  const dispatch: any = useDispatch();
  const [datePicker, setdatePicker] = useState(
    data?.params?.data?.depositDate ? dayjs(data?.params?.data?.depositDate) : dayjs(new Date(Date.now()))
  );
  const [itemStartDate, setItemStartDate] = useState(null);
  const [itemEndDate, setItemEndDate] = useState(null);
  const { loading, totalOverpaymentRemaining, error } = useTotalOverpaymentAmount(data?.params?.data?.tenantId);
  let dueDate = dayjs(data?.params?.data?.dueDate);

  const chequeStatus = data?.params?.data?.chequeStatus?.toLowerCase();
  const currentStatus = data?.params?.data?.currentStaus?.toLowerCase();
  const IspartialPayed = data?.params?.data?.paymentMethodType?.toLowerCase() === "partial";

  const isReceivePaymentAction = selectedOption === "confirm_payment";
  const isEditAction = selectedOption === "edit";
  let checkIsPartial = data?.params?.data?.subPdcs?.some((item) => item?.status?.toLowerCase() === "paid");

  let partialPaidCheque = data?.params?.data?.subPdcs?.filter(
    (item) => item?.status?.toLowerCase() === "paid" && item?.paymentMode?.toLowerCase() === "cheque"
  );

  let makePartialAsBounced = partialPaidCheque?.length > 0 && data?.selectedOption === "mark_as_bounced";
  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);

  const [paymentMode, setPaymentMode] = useState(null);
  const [bankNameFromDropDown, setBankNameFromDropDown] = useState(null);
  const [rawAmountToPay, setRawAmountToPay] = useState(0);
  const debouncedAmountToPay = useDebounce(rawAmountToPay, 500);
  const [isOverPaymentCredit, setIsOverPamentCredit] = useState(false);
  const [paymentStatusOn, setPaymentStatusOn] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [isApprovalBarVisible, setIsApprovalBarVisible] = useState(false);
  const [pendingSubmitValues, setPendingSubmitValues] = useState<any>(null);
  const configData = useSelector((state: any) => state.dashboard.configData);
  const orgData = useSelector((state: any) => state?.tickets?.orgData);
  const bouncedChequeFee = orgData?.bouncedChequeFee?.amount ?? 0;
  const vatPercent = orgData?.bouncedChequeFee?.vatInPercentage ?? 0;

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
  } = useForm({ defaultValues: defaultVal });

  const [onEditBack, setOnEditBack] = useState(false);
  const [depositTo, setDepositTo] = useState(null);
  const status = getValues()?.status?.value;
  let overPaymentCreditValue = totalOverpaymentRemaining;
  let dueAmount = data?.params?.data?.balance ? data?.params?.data?.balance : data?.params?.data?.totalAmount;

  let getBouncedCheque = data?.params?.data?.statusHistory?.filter(
    (cheque) => cheque?.status?.toLowerCase() === "bounce"
  );

  // useWatch without a name will watch all fields in the form
  const allValues = useWatch({ control });

  const onBack = () => {
    if (data?.selectedOption === "bounce_cheque_edit" && paymentStatusOn != "bounce") {
      setOnEditBack(!onEditBack);
    } else {
      reset();
      props.onCancel();
    }
  };

  useInitializePaymentData({
    data,
    onEditBack,
    setValue,
    setPaymentStatusOn,
    setPaymentMode,
    setBankNameFromDropDown,
    bouncedChequeFee,
    orgData,
    visibilityOptions,
    paymentModeOptions,
    bouncedReasons,
    formatString,
  });

  useEffect(() => {
    setBankList(formattedBankList(configData));
  }, [configData?.bankList]);

  useEffect(() => {
    if (!["cheque", "credit_card"].includes(paymentMode)) {
      clearErrors("paymentRef");
    }
  }, [paymentMode, clearErrors]);

  useEffect(() => {
    if (!configData?.bankList) {
      dispatch(getConfigData(["bankList"]));
    }

    return () => {
      reset();
    };
  }, []);

  const handleDateRange = (date) => {
    if (date) {
      setdatePicker(dayjs(date));
    }
  };

  const onModalBack = () => {
    setSubmited(false);
    setisError(false);
  };

  const onDepositTOChange = (e) => {
    setDepositTo(e.value);
    if (data?.params?.data?.payableTo === "owner") {
      setValue("depositAccount", data?.params?.data?.beneficiaryAccount || data?.params?.data?.depositToAccountNumber);
      setValue("depositBank", data?.params?.data?.beneficiaryBank || data?.params?.data?.depositToBank);
    } else if (data?.params?.data?.payableTo === "lessor") {
      setValue("depositAccount", data?.params?.data?.lessorAccountNumber || data?.params?.data?.depositToAccountNumber);
      setValue("depositBank", data?.params?.data?.lessorBankName || data?.params?.data?.depositToBank);
    }
  };

  const amountToPay = Number(debouncedAmountToPay) || 0;
  const dueAmountVar = Number(dueAmount) || 0;
  const creditAmount = Number(overPaymentCreditValue) || 0;
  const credit = isOverPaymentCredit ? Number(creditAmount) || 0 : 0;
  const rawRemaining = dueAmountVar - credit - amountToPay;

  const onNoOverPaymentCridet = () => {
    setIsOverPamentCredit(false);
  };

  const calculateRemainingDue = ({
    dueAmountVar,
    credit = 0,
    pay = 0,
  }: {
    dueAmountVar: number;
    credit?: number;
    pay?: number;
  }) => {
    let remaining = dueAmountVar - credit - pay;

    const paymentMethodValue = allValues?.paymentMethodType?.value;

    const isNoPaymentMade = credit === 0 && pay === 0;
    const isDefaultPaymentMethod = !paymentMethodValue || paymentMethodValue === 1;

    if (!IspartialPayed && isNoPaymentMade && isDefaultPaymentMethod) {
      return 0;
    }

    return remaining;
  };

  const remaining = useMemo(() => {
    return calculateRemainingDue({
      dueAmountVar,
      credit: credit,
      pay: amountToPay,
    });
  }, [dueAmountVar, credit, debouncedAmountToPay, isOverPaymentCredit]);

  useEffect(() => {
    setValue("dueAmount", remaining > 0 ? remaining : 0);
  }, [remaining, credit, isOverPaymentCredit]);

  const paymentMethodTypeValue = useMemo(() => {
    const pay = Number(amountToPay) || 0;
    const creditValue = Number(credit) || 0;

    // 🔹 Do not calculate unless something is entered
    if (pay <= 0 && creditValue <= 0) {
      return undefined; // or return 1 if you want default "Full"
    }

    //  No payment entered
    if (pay <= 0) {
      //  Credit applied → Partial
      if (isOverPaymentCredit && creditValue > 0 && remaining > creditValue) {
        setValue("amountToPay", 0);
        return 2;
      }
      return 1;
    }

    // Explicit overpayment rule
    if (isOverPaymentCredit && creditValue > 0 && rawRemaining < 0) {
      return 3; // Overpayment
    }

    // Normal calculation
    if (rawRemaining < 0) return 3; // Overpayment
    if (remaining === 0) return 1; // Full
    if (remaining > 0) return 2; // Partial

    return undefined;
  }, [amountToPay, credit, isOverPaymentCredit, rawRemaining, remaining]);

  const onPaymentMethodTypeChnage = (e) => {
    const dueAmountValue = Number(dueAmount) > 0 ? Number(dueAmount) : 0;
    const creditValue = isOverPaymentCredit ? Number(credit) || 0 : 0;
    const amountWhenFull = creditValue > 0 ? Math.max(0, dueAmountValue - creditValue) : dueAmountValue;

    if (e?.value === 1 && !checkIsPartial) {
      setValue("amountToPay", amountWhenFull);
      setRawAmountToPay(amountWhenFull);
      setValue("dueAmount", 0);
      return;
    }

    if (e?.value === 1 && checkIsPartial) {
      setValue("amountToPay", amountWhenFull);
      setRawAmountToPay(amountWhenFull);
      setValue("dueAmount", 0);
      return;
    }

    if (e?.value === 2) {
      setValue("amountToPay", undefined);
      setRawAmountToPay(0);
      setValue("dueAmount", dueAmountValue);
      return;
    }
    if (e?.value === 3) {
      // isOverPaymentCredit ? setValue("amountToPay", amountWhenFull) : setValue("amountToPay", undefined);
      setValue("amountToPay", amountWhenFull);
      setRawAmountToPay(0);
      setValue("dueAmount", 0);
      return;
    }
  };

  const helpingText = useMemo(() => {
    const paymentType = allValues?.paymentMethodType?.value;
    const overpaymentAmount = remaining < 0 ? Math.abs(remaining) : 0;
    const hasOverpayment = paymentType === 3 && remaining < 0;
    const hasCreditApplied = isOverPaymentCredit && credit > 0;

    // Credit applied + Overpayment (e.g. user selected Full with credit applied)
    if (hasCreditApplied && hasOverpayment) {
      return `Credit applied: ${currencyFormat(credit)}. Overpayment:  ${currencyFormat(overpaymentAmount)}`;
    }

    // Overpayment only
    if (hasOverpayment) {
      return `Overpayment:${currencyFormat(overpaymentAmount)}`;
    }

    // Credit applied only
    if (hasCreditApplied) {
      return overpaymentAmount && overpaymentAmount > amountToPay
        ? `Credit applied: ${currencyFormat(credit)}. Overpayment:  ${currencyFormat(overpaymentAmount)}`
        : `Credit applied: ${currencyFormat(credit)}`;
    }

    return undefined;
  }, [allValues?.paymentMethodType?.value, remaining, isOverPaymentCredit, credit]);

  const getAmountPaymentTypeError = (amountVal, selectedType) => {
    if (amountVal <= 0 || !selectedType) return null;

    const creditVal = isOverPaymentCredit ? Number(creditAmount) || 0 : 0;
    const dueVal = Number(dueAmount) || 0;

    const remaining = dueVal - creditVal - amountVal;

    let expectedType;
    if (remaining < 0) expectedType = 3;
    else if (remaining === 0) expectedType = 1;
    else expectedType = 2;

    if (amountVal <= 0 && !isOverPaymentCredit && selectedType === 3) {
      return "Amount to pay is required.";
    }
    if (selectedType === expectedType) return null;

    if (remaining < 0) {
      return selectedType === 1 && amountVal < creditVal && isOverPaymentCredit
        ? null
        : "Amount exceeds due amount. Choose Overpayment or reduce the amount.";
    }
    if (remaining > 0) {
      return "Amount is less than due amount. Choose Partial or increase the amount.";
    }
    return "Amount matches due amount. Choose Full payment or adjust amount.";
  };

  useEffect(() => {
    const amountToPayVal = Number(debouncedAmountToPay) || 0;
    const selectedType = allValues?.paymentMethodType?.value;

    if (amountToPayVal <= 0 || !selectedType) {
      clearErrors("amountToPay");
      return;
    }

    const errorMsg = getAmountPaymentTypeError(amountToPayVal, selectedType);
    if (errorMsg) {
      setError("amountToPay", { type: "manual", message: errorMsg });
    } else {
      clearErrors("amountToPay");
    }
  }, [
    debouncedAmountToPay,
    allValues?.paymentMethodType?.value,
    isOverPaymentCredit,
    creditAmount,
    dueAmount,
    setError,
    clearErrors,
  ]);

  // const validatePaymentTypeOnSubmit = (selectedPaymentType) => {
  //   if (selectedPaymentType !== paymentMethodTypeValue) {
  //     if (paymentMethodTypeValue === 3) {
  //       message.error("Entered amount results in an overpayment. Please select Overpayment.");
  //     } else if (paymentMethodTypeValue === 1) {
  //       message.warning("Entered amount clears the full due. Please select Full payment.");
  //     } else if (paymentMethodTypeValue === 2) {
  //       message.warning("Entered amount is a partial payment. Please select Partial payment.");
  //     }

  //     return false;
  //   }

  //   return true;
  // };

  const submitUpdate = async (values) => {
    // --- Validation checks ---
    const paymentStatus = values?.paymentStatus?.value;
    const paymentModeType = values?.paymentModeType?.value;
    const reasonValue = values?.reason?.value ?? "";
    const bankNameValue = values?.bankName?.value;
    const isCheque = paymentMode === "cheque";
    const paymentMethodType = values?.paymentMethodType?.value;
    const amountToPayVal = Number(values?.amountToPay) || 0;
    // return;
    if ((paymentStatus === "bounce" || paymentStatus === "cancelled") && isCheque && !reasonValue) {
      setError("reason", { type: "manual", message: "Please select Reason" });
      return;
    }

    if (amountToPayVal <= 0 && !isOverPaymentCredit && paymentMethodType === 3) {
      setError("amountToPay", { type: "manual", message: "Amount to pay is required" });
      return;
    }
    if (isCheque && !bankNameValue && paymentStatus !== "cancelled") {
      setError("bankName", { type: "manual", message: "Bank Name Required" });
      return;
    }

    const amountError = getAmountPaymentTypeError(amountToPayVal, paymentMethodType);
    if (amountError) {
      setError("amountToPay", { type: "manual", message: amountError });
      return;
    }

    // --- Start processing ---
    setLoader(true);

    const { actualAmount, amount, vat } = calCulateVatInPercent(values?.bouncedChequeFee || 0, values?.vat || 0);

    const payload: Record<string, any> = {
      chequeStatus: paymentStatus,
      modeOfPayment: paymentModeType,
      applyOverpaymentCredit: isOverPaymentCredit,
    };

    if (itemEndDate && itemStartDate) {
      payload["itemEndDate"] = itemEndDate;
      payload["itemStartDate"] = itemStartDate;
    }
    if (makePartialAsBounced && values?.subPdcRef?.value) {
      payload["subPdcId"] = values?.subPdcRef?.value;
      payload["documentNo"] = values?.subPdcRef?.label;
    }
    if (values?.bankName?.label && values?.bankName?.label !== "") {
      payload["bankName"] = values?.bankName?.label;
    }

    if (paymentMethodType) {
      if (paymentMethodType === 1 && !checkIsPartial) {
        payload["paymentMethodType"] = values?.paymentMethodType?.label?.toLowerCase();
      } else if (paymentMethodType === 1 && checkIsPartial) {
        // ***********
        // As per our meeting discussion, if a user chooses to pay
        //  the last remaining amount in full, your API is still
        // treating it as a partial payment, while on the
        // frontend the user has selected ‘Full’.” just
        // for support to backend logic
        // **********
        payload["paymentMethodType"] = "partial";
        payload["amountToPay"] = Number(values?.amountToPay);
      } else if (paymentMethodType === 2) {
        payload["paymentMethodType"] = values?.paymentMethodType?.label?.toLowerCase();
        payload["amountToPay"] = Number(values?.amountToPay);
      } else if (paymentMethodType === 3) {
        payload["paymentMethodType"] = values?.paymentMethodType?.label?.toLowerCase();
        payload["amountToPay"] = Number(values?.amountToPay);
      }
    }
    // Add VAT-related fields if bouncing from paid → bounce
    if (allValues?.paymentStatus?.value === "bounce") {
      payload["penaltyPaymentMode"] = values?.bouncedChequePaymentMode?.value;
      Object.assign(payload, {
        actualAmount: amount,
        penaltyFee: actualAmount,
        vat,
      });
    }

    // Deposit date

    // only depositTo include in payload if user going to pay bugId 14146
    if (paymentStatusOn && paymentStatusOn !== "cancelled" && paymentStatus === "paid") {
      payload.depositDate = dateByformat(datePicker, "YYYY-MM-DD");
    }

    // Document number handling
    if (!makePartialAsBounced) {
      payload.documentNo = data?.params?.data?.bounceToPending
        ? values?.paymentRefReplaced || null
        : values?.paymentRef;
    }

    // Reason handling
    if (isCheque) {
      if (paymentStatusOn !== "pending") {
        if (paymentStatusOn !== "paid") {
          payload.reason = payload.documentNo ? `${reasonValue} Cheque Number ${payload.documentNo}` : reasonValue;
        }
      }
      if (paymentStatusOn === "cancelled") {
        payload.reason = reasonValue;
      }
      if (paymentStatusOn === "bounce") {
        payload.reason = payload.documentNo ? `${reasonValue} Cheque Number ${payload.documentNo}` : reasonValue;

        if (!makePartialAsBounced) {
          payload.paymentRefReplaced = values?.paymentRefReplaced;
        }
      }
    }

    // Optional note
    if (values?.paymentNote) {
      payload.paymentNote = values.paymentNote;
    }

    // Deposit to case
    const payableTo = data?.params?.data?.payableTo;

    if (depositTo || values?.depositTo?.value) {
      if (payableTo === "owner" && paymentStatus === "paid") {
        Object.assign(payload, {
          depositTo: depositTo || values?.depositTo?.value,
          depositToAccountNumber: values?.depositAccount,
          depositToBank: values?.depositBank,
          depositToIBAN: data?.params?.data?.beneficiaryIBAN,
        });
      } else if (payableTo === "lessor" && paymentStatus === "paid") {
        Object.assign(payload, {
          depositTo: depositTo || values?.depositTo?.value,
          lessorAccountNumber: values?.depositAccount,
          lessorBankName: values?.depositBank,
          depositToIBAN: data?.params?.data?.beneficiaryIBAN,
        });
      }
    }

    // --- API call ---
    try {
      const result = await updatePDCStatus(
        {
          leaseId: data?.params?.data?.leaseId,
          pdcId: data?.params?.data?._id,
        },
        removeEmptyValues(payload)
      );

      if (result === 200) {
        reset();
        message.success("Status updated successfully");
        setSubmited(false);
        props.onUpdate?.();
      } else {
        message.error(result?.response?.data?.error || "Something went wrong");
        setErrorMessage(result?.response?.data?.error);
        setisError(true);
      }
    } catch (error: any) {
      const { response } = error;
      console.log(response, "response");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Form layout="vertical" className="bf-main payment-form" onFinish={handleSubmit((e) => submitUpdate(e))}>
      {!submited ? (
        <Card>
          {loader && !isError && (
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Space size={24} className="w-100 text-center" direction="vertical">
                  <Spin size="large" className="ag-fontSize32" />
                </Space>
              </Col>
            </Row>
          )}
          <ApprovalBar
            isVisible={isApprovalBarVisible && isReceivePaymentAction}
            message="A credit note request is still pending for this invoice. Do you want to continue?"
            containerStyle={{ marginBottom: 24 }}
            primaryButton={{
              label: "Yes",
              onClick: async () => {
                if (!pendingSubmitValues) return;
                setIsApprovalBarVisible(false);
                const values = pendingSubmitValues;
                setPendingSubmitValues(null);
                await submitUpdate(values);
              },
            }}
            secondaryButton={{
              label: "No",
              onClick: () => {
                setIsApprovalBarVisible(false);
                setPendingSubmitValues(null);
              },
            }}
          />
          <Row gutter={24}>
            {overPaymentCreditValue > 0 && selectedOption === "confirm_payment" && (
              <Tag className="invoic-fm-status-header" color="cyan">
                {isOverPaymentCredit ? (
                  <Row>
                    <Col
                      span={24}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Space size={5}>
                        <InfoCircleOutlined /> &nbsp; Overpayment credit of AED {overPaymentCreditValue} has been
                        applied to this invoice.
                        <Button
                          onClick={() => onNoOverPaymentCridet()}
                          className="ef-reject-btn"
                          htmlType="button"
                          style={{ marginLeft: 8 }}
                        >
                          Undo
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                ) : (
                  <Row>
                    <Col
                      span={24}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Space size={5}>
                        <InfoCircleOutlined /> &nbsp; This lease has an overpayment credit of AED{" "}
                        {overPaymentCreditValue}. Click (Yes) to apply the credit to this invoice.
                        <Button
                          type="primary"
                          onClick={() => setIsOverPamentCredit(true)}
                          className="ef-approve-btn"
                          htmlType="button"
                          style={{ marginLeft: 8 }}
                        >
                          Yes
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                )}
              </Tag>
            )}
            <Col span={24}>
              {((getBouncedCheque?.length > 0 && paymentStatusOn === "pending") ||
                data?.params?.data?.bounceToPending) && (
                <Grid
                  data={getBouncedCheque?.reverse()}
                  columns={gridCol}
                  pagination={false}
                  defaultSettings={gridProps}
                  domLayout={true}
                  height={getBouncedCheque?.length >= 2 ? "200px" : "130px"}
                  maxHeight={"300px"}
                  overlayNoRowsTemplate={"data cannot be found."}
                />
              )}
            </Col>

            {!(
              getBouncedCheque?.length > 0 &&
              paymentStatusOn === "pending" &&
              data?.params?.data?.chequeStatus?.toLowerCase() === "bounce"
            ) && (
              <>
                <Col span={12}>
                  <Form.Item label={`Due Date`}>
                    <DatePicker
                      disabled={true}
                      style={{ width: "100%" }}
                      defaultValue={dueDate}
                      value={dueDate}
                      format="DD-MM-YYYY"
                      size="middle"
                      picker="date"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <RangePickerField
                    isRequired={true}
                    control={control}
                    disabled={!isEditAction && !isReceivePaymentAction}
                    label="Invoice Period (From/To)"
                    setValue={setValue}
                    fieldname="invoicePeriod"
                    validate={errors.invoicePeriod && "error"}
                    // initValue={rangePickerInitialValue(data, "invice_period")}
                    rules={{ required: "Invoice Period Required" }}
                    onDateChange={(date) => {
                      if (date) {
                        setItemStartDate(dateByformat(date[0], "YYYY-MM-DD"));
                        setItemEndDate(dateByformat(date[1], "YYYY-MM-DD"));
                      }
                    }}
                    iProps={{
                      suffixIcon: <Calendar />,
                      format: DATE_FORMATS.display,
                      placeholder: ["Start Date", "End Date"],
                    }}
                    validMessage={errors.invoicePeriod && errors.invoicePeriod.message}
                  />
                </Col>
                {data?.params?.data?.currentStaus !== "paid" && (
                  <>
                    <Col span={12} style={{ marginTop: "5px" }}>
                      <ReactSelectField
                        fieldname="paymentMethodType"
                        isRequired={true}
                        label="Paid Type"
                        control={control}
                        iProps={{
                          placeholder: "Select one",
                          isDisabled:
                            data?.params?.data?.chequeStatus !== "paid" ||
                            data?.params?.data?.currentStaus === "paid" ||
                            makePartialAsBounced,
                        }}
                        selectOption={[
                          { label: "Full", value: 1 },
                          { label: "Partial", value: 2 },
                          { label: "Overpayment", value: 3 },
                        ]}
                        onChange={(e) => onPaymentMethodTypeChnage(e)}
                        rules={{ required: "Payment Type Required" }}
                        validate={errors.paymentMethodType && "error"}
                        validMessage={errors.paymentMethodType ? errors.paymentMethodType.message : ""}
                      />
                    </Col>

                    <Col span={12} style={{ marginTop: "5px" }}>
                      <InputNumberField
                        fieldname="totalBalance"
                        label="Due Amount"
                        format="currency"
                        control={control}
                        disabled
                        inputNumberProps={{
                          placeholder: "Due Amount",
                          min: 0,
                        }}
                      />
                    </Col>
                    <Col span={12} style={{ marginTop: "5px" }}>
                      <InputNumberField
                        isRequired
                        fieldname="amountToPay"
                        label="Amount To Pay"
                        format="currency"
                        control={control}
                        disabled={
                          allValues?.paymentMethodType?.value === 1 ||
                          data?.params?.data?.chequeStatus !== "paid" ||
                          makePartialAsBounced
                            ? true
                            : false
                        }
                        inputNumberProps={{
                          placeholder: "Amount To Pay",
                          min: 0,
                          // max: allValues?.paymentMethodType?.value !== 3 ? dueAmount : undefined,
                        }}
                        onChange={(value) => setRawAmountToPay(Number(value) || 0)}
                        rules={{
                          required: "Amount To Pay Required",
                          validate: (value) => {
                            const errorMsg = getAmountPaymentTypeError(
                              Number(value) || 0,
                              allValues?.paymentMethodType?.value
                            );
                            return errorMsg || true;
                          },
                        }}
                      />
                    </Col>

                    <Col span={12} style={{ marginTop: "5px" }}>
                      <InputNumberField
                        fieldname="dueAmount"
                        label="Balance"
                        format="currency"
                        control={control}
                        disabled
                        inputNumberProps={{
                          placeholder: "Balance",
                          min: 0,
                        }}
                        formItemProps={{ extra: helpingText }}
                      />
                    </Col>
                  </>
                )}

                {
                  <Col span={12} style={{ marginTop: "5px" }}>
                    <ReactSelectField
                      fieldname="paymentModeType"
                      isRequired={true}
                      label="Payment Mode"
                      rules={{ required: "Payment Mode Required" }}
                      validate={errors.paymentModeType && "error"}
                      validMessage={errors.paymentModeType && errors.paymentModeType.message}
                      control={control}
                      iProps={{
                        placeholder: "Select payment mode",
                        isDisabled:
                          (chequeStatus === "pending" && currentStatus === "bounce") ||
                          (chequeStatus === "paid" && currentStatus !== "pending") ||
                          currentStatus === "settled" ||
                          data?.params?.data?.bounceToPending,
                      }}
                      selectOption={paymentModeRendering(data)}
                      onChange={(e) => {
                        if (e) setPaymentMode(e.value);
                      }}
                    />
                  </Col>
                }

                <Col span={12} style={{ marginTop: "5px" }}>
                  <ReactSelectField
                    isRequired={true}
                    key={allValues?.paymentModeType?.value}
                    fieldname="paymentStatus"
                    label={`Payment Status (${convertToSpacedLowerCase(currentStatus)})`}
                    selectOption={[]}
                    control={control}
                    iProps={{
                      placeholder: "Select payment status",
                      isDisabled: true,
                    }}
                    placeholder="Select One"
                    rules={{ required: "Payment Staus Required" }}
                    validate={errors.paymentStatus && "error"}
                    validMessage={errors.paymentStatus && errors.paymentStatus.message}
                    onChange={(e) => {
                      if (e) {
                        if (e.value === "cancelled") {
                          setValue(
                            "reason",
                            {
                              value: bouncedReasons[0]?.value,
                              label: bouncedReasons[0]?.label,
                            },
                            { shouldValidate: false }
                          );
                        }
                        setPaymentStatusOn(e.value);
                        clearErrors();
                      }
                    }}
                  />
                </Col>

                {paymentStatusOn && paymentStatusOn !== "cancelled" && (
                  <Col span={12}>
                    {makePartialAsBounced ? (
                      <ReactSelectField
                        isRequired={true}
                        fieldname="subPdcRef"
                        label="Payment Ref"
                        control={control}
                        setValue={setValue}
                        iProps={{
                          placeholder: "Select Payment Ref",
                          // isDisabled: data?.params?.data?.bounceToPending,
                        }}
                        rules={{ required: "Payment Ref Required" }}
                        selectOption={partialPaidCheque?.map((pdc) => {
                          return {
                            label: pdc?.documentNo,
                            value: pdc?.subPdcId,
                          };
                        })}
                        validate={errors.subPdcRef && errors.subPdcRef}
                        validMessage={errors.subPdcRef && errors.subPdcRef.message}
                      />
                    ) : (
                      <InputField
                        key={`${allValues?.paymentStatus?.value}-${paymentStatusOn}-${paymentMode}`} // dynamic key okay
                        fieldname="paymentRef"
                        label="Payment Ref"
                        isRequired={["cheque", "credit_card"].includes(paymentMode)}
                        control={control}
                        disabled={
                          (getBouncedCheque?.length > 0 &&
                            paymentStatusOn === "pending" &&
                            data?.params?.data?.chequeStatus?.toLowerCase() === "bounce") ||
                          data?.params?.data?.currentStaus?.toLowerCase() === "paid" ||
                          data?.params?.data?.bounceToPending ||
                          data?.params?.data?.currentStaus?.toLowerCase() === "settled"
                        }
                        iProps={{
                          placeholder: "Enter Payment Ref",
                        }}
                        initValue=""
                        rules={{
                          required: ["cheque", "credit_card"].includes(paymentMode) ? "Payment Ref Required" : false,
                        }}
                        validate={!!errors.paymentRef && "error"}
                        validMessage={errors.paymentRef?.message}
                      />
                    )}
                  </Col>
                )}

                {paymentStatusOn && paymentStatusOn !== "cancelled" && (
                  <Col span={12}>
                    {
                      <ReactSelectField
                        key={paymentMode}
                        fieldname="bankName"
                        isRequired={paymentMode === "cheque" ? true : false}
                        label={"Bank Name"}
                        rules={{
                          required: paymentMode === "cheque" ? "Bank Name Required" : false,
                        }}
                        iProps={{
                          isDisabled:
                            (getBouncedCheque?.length > 0 &&
                              paymentStatusOn === "pending" &&
                              data?.params?.data?.chequeStatus?.toLowerCase() === "bounce" &&
                              data?.params?.data?.chequeStatus?.toLowerCase() === "paid") ||
                            data?.params?.data?.currentStaus?.toLowerCase() === "paid" ||
                            data?.params?.data?.chequeStatus?.toLowerCase() === "bounce" ||
                            data?.params?.data?.bounceToPending ||
                            data?.params?.data?.currentStaus?.toLowerCase() === "settled",
                        }}
                        validate={paymentMode === "cheque" ? errors.bankName && "error" : false}
                        validMessage={paymentMode === "cheque" ? errors.bankName && errors.bankName.message : false}
                        control={control}
                        placeholder={"Enter Bank Name"}
                        selectOption={bankList || []}
                        onChange={(e) => {
                          setBankNameFromDropDown(e.value);
                        }}
                        initValue={null}
                      />
                    }
                  </Col>
                )}

                {paymentStatusOn && paymentStatusOn === "paid" && paymentMode === "cheque" && (
                  <Col span={12}>
                    <Form.Item label={`Deposit Date`}>
                      <DatePicker
                        disabled={data?.params?.data?.currentStaus?.toLowerCase() === "paid"}
                        style={{ width: "100%" }}
                        defaultValue={datePicker}
                        value={datePicker}
                        format="DD-MM-YYYY"
                        disabledDate={(current) => {
                          const isPastDate = current && current.valueOf() > Date.now();
                          return isPastDate;
                        }}
                        size="middle"
                        picker="date"
                        onChange={handleDateRange}
                      />
                    </Form.Item>
                  </Col>
                )}

                {/*  for deposit To section when payment status is paid start from here */}

                {(allValues?.paymentStatus?.value === "paid" || paymentStatusOn === "paid") && (
                  <>
                    <Col span={12}>
                      <ReactSelectField
                        fieldname="depositTo"
                        label="Deposit To"
                        control={control}
                        setValue={setValue}
                        onChange={(e) => onDepositTOChange(e)}
                        iProps={{
                          placeholder: "Deposit To",
                          isDisabled:
                            data?.params?.data?.currentStaus?.toLowerCase() === "paid" ||
                            data?.params?.data?.currentStaus?.toLowerCase() === "settled" ||
                            currentStatus === "transfer_in_progress",
                        }}
                        selectOption={
                          data?.params?.data?.depositTo
                            ? [
                                {
                                  label: data?.params?.data?.depositTo,
                                  value: data?.params?.data?.depositTo,
                                },
                              ]
                            : []
                        }
                      />
                    </Col>

                    <Col span={12}>
                      <InputField
                        fieldname="depositBank"
                        // isRequired={true}
                        label={"Deposit Bank"}
                        control={control}
                        disabled={true}
                        setValue={setValue}
                        iProps={{
                          placeholder: "Deposit Bank",
                        }}
                        initValue=""
                        valueGot={data?.params?.data?.depositToBank || data?.params?.data?.beneficiaryBank}
                        // rules={{ required: "Bank Name Required" }}
                        // validate={errors.bankName && "error"}
                        // validMessage={errors.bankName && errors.bankName.message}
                      />
                    </Col>

                    <Col span={12}>
                      <InputNumberField
                        fieldname="depositAccount"
                        label="Deposit Account"
                        format="number"
                        control={control}
                        disabled
                        inputNumberProps={{
                          placeholder: "Deposit Account",
                        }}
                        // rules={{ required: "Bank Name Required" }}
                        // validate={errors.bankName && "error"}
                        // validMessage={errors.bankName && errors.bankName.message}
                      />
                    </Col>
                  </>
                )}
              </>
            )}
            {paymentMode === "cheque" &&
              (paymentStatusOn === "bounce" ||
                paymentStatusOn === "cancelled" ||
                data?.params?.data?.chequeStatus?.toLowerCase() === "cancelled") && (
                <Col span={12}>
                  <ReactSelectField
                    fieldname="reason"
                    label="Reason"
                    validate={errors.reason && "error"}
                    control={control}
                    iProps={{
                      placeholder: "Select reason",
                      isDisabled: data?.params?.data?.bounceToPending,
                    }}
                    selectOption={bouncedReasons}
                    isRequired={true}
                    rules={{ required: "Please select Reason" }}
                    validMessage={errors.reason && errors.reason.message}
                  />
                </Col>
              )}
            {status !== "paid" && paymentMode !== "cheque" && <Col span={12}></Col>}

            {paymentMode === "cheque" &&
              (allValues?.paymentStatus?.value === "bounce" || paymentStatusOn === "bounce") && (
                <Col span={12}>
                  <ReactSelectField
                    fieldname="bouncedChequePaymentMode"
                    label="Bounced Cheque Payment Mode"
                    control={control}
                    iProps={{
                      placeholder: "Enter Payment Mode",
                      isDisabled: data?.params?.data?.bounceToPending,
                    }}
                    selectOption={paymentModeOptions}
                  />
                </Col>
              )}
            {paymentMode === "cheque" &&
              (allValues?.paymentStatus?.value === "bounce" || paymentStatusOn === "bounce") && (
                <>
                  <Col span={12}>
                    <InputField
                      fieldname="bouncedChequeFee"
                      label={`Bounced Cheque Fee`}
                      control={control}
                      disabled //={data?.params?.data?.bounceToPending}
                      iProps={{
                        placeholder: "Bounced Cheque Fee",
                        min: 0,
                        type: "number",
                      }}
                      initValue={bouncedChequeFee || 0}
                    />
                  </Col>

                  <Col span={12}>
                    <InputField
                      fieldname="vat"
                      label={`Vat %`}
                      control={control}
                      disabled //={data?.params?.data?.bounceToPending}
                      iProps={{
                        placeholder: "Vat",
                        min: 0,
                        type: "number",
                      }}
                      initValue={vatPercent || 0}
                    />
                  </Col>
                </>
              )}

            {!(
              getBouncedCheque?.length > 0 &&
              paymentStatusOn === "pending" &&
              !data?.params?.data?.bounceToPending
            ) && (
              <Col span={24}>
                <TextAreaField
                  disabled={data?.params?.data?.bounceToPending}
                  label={`Note`}
                  fieldname="paymentNote"
                  iProps={{ placeholder: "Note...." }}
                  initValue=""
                  setValue={setValue}
                  control={control}
                  valueGot={data?.params?.data?.paymentNote}
                />
              </Col>
            )}

            {((getBouncedCheque?.length > 0 &&
              paymentStatusOn === "pending" &&
              data?.params?.data?.chequeStatus?.toLowerCase() === "bounce") ||
              data?.params?.data?.bounceToPending) && (
              <>
                <Col span={24}>
                  <h3>Replaced Payment Details</h3>
                </Col>

                <Col span={12}>
                  <ReactSelectField
                    fieldname="paymentModeType"
                    key={paymentStatusOn}
                    validate={errors.paymentModeType && "error"}
                    isRequired={true}
                    label="Payment Mode"
                    control={control}
                    iProps={{
                      placeholder: "Select payment mode",
                    }}
                    rules={{ required: "Required" }}
                    validMessage={errors.paymentModeType && errors.paymentModeType.message}
                    selectOption={paymentModeOptions}
                    onChange={(e) => {
                      if (e) setPaymentMode(e.value);
                    }}
                  />
                </Col>

                <Col span={12}></Col>

                <Col span={12}>
                  {
                    <InputField
                      key={allValues?.paymentStatus?.value + paymentStatusOn}
                      fieldname="paymentRefReplaced"
                      label={"Payment Ref"}
                      isRequired={paymentMode === "cheque" ? true : false}
                      control={control}
                      iProps={{
                        placeholder: "Enter Payment Ref",
                      }}
                      validate={errors.paymentRefReplaced && "error"}
                      validMessage={errors.paymentRefReplaced && errors.paymentRefReplaced.message}
                      rules={{ required: "Required" }}
                      initValue=""
                    />
                  }
                </Col>

                <Col span={12}>
                  <ReactSelectField
                    fieldname="bankName"
                    isRequired={true}
                    label={"Bank Name"}
                    control={control}
                    placeholder={"Enter Bank Name"}
                    iProps={{
                      isDisabled: data?.params?.data?.chequeStatus?.toLowerCase() === "paid",
                    }}
                    selectOption={bankList || []}
                    initValue={""}
                    onChange={(e) => {
                      setBankNameFromDropDown(e.value);
                    }}
                  />
                </Col>
              </>
            )}
          </Row>
          <Row gutter={24} justify="space-between">
            <Col>
              <Button
                className="ef-discard-btn"
                onClick={() => onBack()}
                disabled={isApprovalBarVisible && isReceivePaymentAction}
              >
                Back
              </Button>
            </Col>
            <Col>
              <Button
                disabled={(loader && !isError) || (isApprovalBarVisible && isReceivePaymentAction)}
                type="primary"
                className="ef-approve-btn"
                htmlType="submit"
              >
                {loader && !isError ? "Loading..." : "Update"}
              </Button>
            </Col>
          </Row>
        </Card>
      ) : (
        isError && (
          <>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Space size={24} className="w-100 text-center" direction="vertical">
                  <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                  <Paragraph className="ag-error fontWeight600 mb-0">{errorMessage}</Paragraph>
                </Space>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Button className="ef-discard-btn" htmlType="button" onClick={() => onModalBack()}>
                  Back
                </Button>
              </Col>
            </Row>
          </>
        )
      )}
    </Form>
  );
};

export default React.memo(ModifyPaymentStatus);
